// 路由表 + 菜单码；权限由 menus.ts 决定可见性。
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  { path: '/admin/login', component: () => import('@/views/login/index.vue'), meta: { code: 'public', title: '登录' } },
  {
    path: '/admin',
    component: () => import('@/layouts/DefaultLayout.vue'),
    meta: { code: 'app' },
    children: [
      { path: '', redirect: '/admin/dashboard' },
      { path: 'dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { code: 'dashboard', title: '数据看板' } },
      { path: 'users', component: () => import('@/views/users/List.vue'), meta: { code: 'users', title: '用户管理' } },
      { path: 'users/usage', component: () => import('@/views/users/UsageOverview.vue'), meta: { code: 'users', title: '用户使用情况概览' } },
      { path: 'paywall', component: () => import('@/views/paywall/List.vue'), meta: { code: 'paywall', title: '订阅套餐' } },
      { path: 'paywall/entitlements', component: () => import('@/views/paywall/Entitlements.vue'), meta: { code: 'paywall', title: '权益管理' } },
      { path: 'paywall/config', component: () => import('@/views/paywall/PaymentConfig.vue'), meta: { code: 'paywall', title: '支付密钥配置' } },
      { path: 'skins', component: () => import('@/views/skin/List.vue'), meta: { code: 'skin', title: '皮肤装扮中心' } },

      { path: 'finance', component: () => import('@/views/finance/Topups.vue'), meta: { code: 'finance', title: '充值流水' } },
      { path: 'finance/topups/:id', component: () => import('@/views/finance/TopupDetail.vue'), meta: { code: 'finance', title: '充值明细' } },
      { path: 'finance/refunds', component: () => import('@/views/finance/Refunds.vue'), meta: { code: 'finance', title: '退款流水' } },
      { path: 'finance/reconcile', component: () => import('@/views/finance/Reconcile.vue'), meta: { code: 'finance', title: '财务对账' } },
      { path: 'lexicon', component: () => import('@/views/lexicon/List.vue'), meta: { code: 'lexicon', title: '词库管理' } },
      { path: 'ai', component: () => import('@/views/ai/List.vue'), meta: { code: 'ai', title: 'AI 配置' } },
      { path: 'attribution', component: () => import('@/views/attribution/List.vue'), meta: { code: 'attribution', title: '广告归因' } },
      { path: 'biz', component: () => import('@/views/biz/List.vue'), meta: { code: 'biz', title: '商务组织' } },
      { path: 'rbac', component: () => import('@/views/rbac/roles/List.vue'), meta: { code: 'rbac', title: '运营后台权限' } },
      { path: 'audit', component: () => import('@/views/audit/List.vue'), meta: { code: 'audit', title: '审计日志' } },
      { path: 'profile', component: () => import('@/views/profile/index.vue'), meta: { code: 'profile', title: '个人信息' } },
      { path: 'profile/password', component: () => import('@/views/profile/Password.vue'), meta: { code: 'profile', title: '修改密码' } },
    ],
  },
  // ── 企业专属门户（/biz-portal / /portal）：独立登录体系（client_users JWT），
  //    与平台管理员后台完全隔离；meta.code=public 用于绕过平台 authGuard/mfaGuard，
  //    登录校验由页面内 usePortalAuthStore 自行处理。
  { path: '/biz-portal/login', component: () => import('@/views/portal/Login.vue'), meta: { code: 'public', title: '企业登录' } },
  { path: '/biz-portal', component: () => import('@/views/portal/Home.vue'), meta: { code: 'public', title: '企业管理后台' } },
  { path: '/portal/login', redirect: '/biz-portal/login' },
  { path: '/portal', redirect: '/biz-portal' },

  { path: '/:path(.*)', redirect: '/admin' },
]

export default routes
